// extracted by mini-css-extract-plugin
export default {"container":"Header_container__-t+Wv","logo":"Header_logo__Ew5nE"};